import { render, staticRenderFns } from "./AcceptIcon.vue?vue&type=template&id=4c1c4662"
import script from "./AcceptIcon.vue?vue&type=script&lang=js"
export * from "./AcceptIcon.vue?vue&type=script&lang=js"
import style0 from "./AcceptIcon.vue?vue&type=style&index=0&id=4c1c4662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports